/**
 * Icon that represents the kind of an activity, for example a coffee cup for an
 * appointment. Shared by every place that lists activities — table cells, the
 * follow-up sublist and the activity timeline — so the same type is always
 * recognizable by the same icon.
 *
 * @param typeValue Raw `type` attribute of the activity. Unknown values and
 *   missing types fall back to the generic activity icon.
 * @returns Name of an icon of the `Icon` atom.
 */
export const getActivityTypeIcon = (typeValue: unknown): string => {
  switch (typeValue) {
    case 'APPOINTMENT':
      return 'coffee'
    case 'CORRESPONDENCE':
      return 'mail'
    case 'CALL':
      return 'call'
    case 'MARKETING_AUTOMATION_EVENT':
      return 'email-opened'
    case 'MEMO':
      return 'note'
    case 'TASK':
      return 'clipboard'
    default:
      return 'activity'
  }
}
